import styled from '@emotion/styled'

export const ActionsWrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
`
